<main kendoRippleContainer class="viewport viewport-full">
  <router-outlet />
</main>

@if (errorService.visible()) {
  <kendo-dialog
    [title]="'attention' | translate"
    (close)="errorService.close()"
  >
    <div
      [innerHTML]="(errorService.isServerError() ? 'errorServerCommunication' : 'errorUnknown') | translate"
      style="color: white"
    ></div>
    <kendo-dialog-actions style="flex-direction: column; gap: 8px;">
      @if (errorService.report()) {
        <button
          style="width: 100%"
          kendoButton
          fillMode="outline"
          [themeColor]="'primary'"
          [svgIcon]="copied() ? icons.checkOutlineIcon : icons.copyIcon"
          (click)="copyError()"
        >
          {{ (copied() ? "copied" : "copyError") | translate }}
        </button>
        <button
          style="width: 100%"
          kendoButton
          fillMode="outline"
          [themeColor]="'primary'"
          [svgIcon]="icons.envelopIcon"
          (click)="sendErrorReport()"
        >
          {{ "sendErrorReport" | translate }}
        </button>
      }
      <button
        style="width: 100%"
        kendoButton
        [themeColor]="'primary'"
        (click)="errorService.close()">
        {{ "close" | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
